import React from "react";
import SearchOrAddDropdown from "../../AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/NurtureCampaignContact/SearchOrAddDropdown";
import SimpleDateField from "../../genericComponents/simpleTextField/SimpleDateField";
import GenericBanner from "../../genericComponents/uiElements/GenericBanner";
import SimpleTextAreaField from "../../genericComponents/simpleTextField/SimpleTextAreaField";
import { formatDateToYMD } from "../../../../utilities/dateUtils";
import SimpleThemedButton from "../../genericComponents/simpleTextField/SimpleThemedButton";
import SimpleTextField from "../../genericComponents/simpleTextField/SimpleTextField";

function GlobalContactFindNurtureInit({
  productList,
  currentCampDetails,
  setCurrentCampDetails,
  generateEmailsCallBack = () => {},
}) {
  const {
    campaignName,
    selectedProducts = [],
    emailGenerationCount,
    startDate,
    context,
    productLink
  } = currentCampDetails || {};

  console.log(
    "currentCampDetails?.selectedProducts",
    currentCampDetails?.selectedProducts?.length
  );

  return (
    <div>
      <div style={{ width: "50%" }}>
        {/* Campaign Name */}
        <span
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "1rem",
          }}
        >
          <SimpleTextField
            value={campaignName}
            setValue={(e) =>
              setCurrentCampDetails((prev) => ({
                ...prev,
                campaignName: e.target.value,
              }))
            }
          />
        </span>

        {/* What are you selling */}
        <span
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "1.5rem",
          }}
        >
          <label className="nccs-field">
            <span className="nccs-label stf-label">What Are You Selling ?</span>
            <span
              className="what_selling_wrapper"
              style={{ display: "flex", gap: "1rem", alignItems: "center" }}
            >
              <SearchOrAddDropdown
                placeholder="Choose One or More Products"
                options={productList}
                value={selectedProducts}
                onChange={(val) =>
                  setCurrentCampDetails((prev) => ({
                    ...prev,
                    selectedProducts: val,
                  }))
                }
                mode="multiple"
                showCount={false}
                noEditPlaceHolder={true}
                valueKey="name"
                labelKey="name"
                returnType="object"
                searchMode="search"
              />
              <div className="selected_count">
                {currentCampDetails?.selectedProducts?.length > 0 && (
                  <>{currentCampDetails?.selectedProducts?.length} Selected</>
                )}
              </div>
            </span>
          </label>
        </span>

        {/* Emails per contact */}
        <label className="nccs-field">
          <span className="nccs-label stf-label">
            Number of emails to generate per contact
          </span>
          <SearchOrAddDropdown
            placeholder="e.g, 3"
            options={[
              { label: 1, value: 1 },
              { label: 2, value: 2 },
              { label: 3, value: 3 },
            ]}
            value={emailGenerationCount}
            onChange={(val) =>
              setCurrentCampDetails((prev) => ({
                ...prev,
                emailGenerationCount: val,
              }))
            }
            mode="single"
            showCount={false}
            returnType="value"
            labelKey="label"
            valueKey="value"
            searchMode="search-only"
          />
        </label>

        {/* Campaign Start Date */}
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            margin: "1rem 0",
          }}
        >
          <SimpleDateField
            disablePastDates={true}
            label="Campaign Start Date"
            labelPosition="top-left"
            value={formatDateToYMD(new Date(startDate))}
            onChange={(val) =>
              setCurrentCampDetails((prev) => ({
                ...prev,
                startDate: formatDateToYMD(new Date(val)),
              }))
            }
            minDate={new Date(2020, 0, 1)}
            maxDate={new Date(2030, 11, 31)}
            disableWeekends
            customWidth="100%"
          />

          {formatDateToYMD(new Date(startDate)) <
            formatDateToYMD(new Date()) && (
            <GenericBanner
              type="error"
              message="Date cannot be less than today"
            />
          )}
        </span>
        <span style={{ marginTop: "2rem" }}>
        <SimpleTextField 
          label="Product Link"
          placeholder="Enter Product Link"
              value={productLink}
              setValue={(e) =>
                setCurrentCampDetails((prev) => ({
                  ...prev,
                  productLink: e.target.value,
                }))
              }
            />
      </span>
      </div>

      {/* Context */}
      <span style={{ marginTop: "2rem" }}>
        <SimpleTextAreaField
          label="Campaign Context"
          placeholder="Describe the purpose and tone for this campaign…"
          rows={5}
          value={context}
          onChange={(e) =>
            setCurrentCampDetails((prev) => ({
              ...prev,
              context: e.target.value,
            }))
          }
          customWidth="100%"
        />
      </span>

      {/* Bottom Fixed CTA */}
      <div
        style={{
          position: "fixed",
          width: "100%",
          borderTop: "1px solid #E2E8F0",
          right: 0,
          bottom: 0,
          padding: "0.5rem",
          backgroundColor: "#F2F6FB",
          display: "flex",
          justifyContent: "flex-end",
          zIndex: 1000,
        }}
      >
        <SimpleThemedButton
          buttonText="Generate Personalized Emails"
          btnDisabled={
            !(
              currentCampDetails?.campaignName?.length > 0 &&
              currentCampDetails?.selectedProducts?.length > 0 &&
              currentCampDetails?.emailGenerationCount > 0 &&
              currentCampDetails?.context?.length > 5
            )
          }
          onBtnClick={generateEmailsCallBack}
        />
      </div>
    </div>
  );
}

export default GlobalContactFindNurtureInit;
